<template>
  <InputSelect
    :error-fields="errorFields"
    :model-value="modelValue"
    :name="name"
    :options="affiliates"
    :submitted="submitted"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <slot />
  </InputSelect>
</template>

<script setup>
import useAxios from "@/composables/axios";

import InputSelect from './InputSelect.vue';

defineProps({
  errorFields: {
    type: Object,
    required: true
  },
  submitted: {
    type: Boolean,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  modelValue: {
    type: String,
    default: null
  }
})

defineEmits(['update:modelValue'])

const axios = useAxios()

const affiliateResp = await axios.get('/affiliate/list')
const affiliates = affiliateResp.data.map((wasteCode) => {
  return {
    id: wasteCode.uuid,
    label: wasteCode.name
  }
})

</script>